// DocsProvider.js
import { useState, useEffect, useRef } from "react";
import { DocsContext } from "./Context";
import { useParams, useSearchParams } from "react-router-dom";
import api from "../../api/axios";

export const DocsProvider = ({ children }) => {
  const [searchParams] = useSearchParams();
  const caseId = searchParams.get("id");
  const activeRequestRef = useRef(0);
  const [docsInfo, setDocsInfo] = useState({});
  const [docsInfoTransfered, setDocsInfoTransfered] = useState({});
  const [docsLoading, setDocsLoading] = useState(true);
  const [docsFlag, setDocsFlag] = useState(false);
  const [docFlagTransfered, setDocFlagTransfered] = useState(false);
  const [docsChangedFlag, setDocsChangedFlag] = useState(false);

  const getDocsInfo = async (case_id = 0) => {
    const requestId = activeRequestRef.current + 1;
    activeRequestRef.current = requestId;

    try {
      // Reset previous snapshots so UI does not treat stale docs as freshly rendered.
      setDocsInfo({});
      setDocsInfoTransfered({});
      setDocsFlag(false);
      setDocFlagTransfered(false);
      setDocsLoading(true);

      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/s3/show/${
          case_id ? case_id : caseId
        }`,
        {},
      );

      if (requestId !== activeRequestRef.current) {
        return;
      }

      const groupedByCase = getGroupedCase(data?.files);

      if (data?.mergedFilesTransfered) {
        const groupedByTransferedCases = getGroupedCase(
          data?.mergedFilesTransfered,
        );

        if (Object.keys(groupedByTransferedCases).length === 0) {
          setDocFlagTransfered(false);
        } else {
          setDocFlagTransfered(true);
        }

        setDocsInfoTransfered(groupedByTransferedCases);
      }

      if (Object.keys(groupedByCase).length === 0) {
        setDocsFlag(false);
      } else {
        setDocsFlag(true);
      }

      if (
        Object.keys(groupedByCase).length === 0 &&
        (!data?.mergedFilesTransfered ||
          Object.keys(getGroupedCase(data?.mergedFilesTransfered)).length === 0)
      ) {
        setDocsLoading(false);
      }

      setDocsInfo(groupedByCase);
    } catch (error) {
      if (requestId !== activeRequestRef.current) {
        return;
      }

      const response = error?.response;
      const requestUrl = `${process.env.REACT_APP_API_URL}/s3/show/${
        case_id ? case_id : caseId
      }`;

      console.groupCollapsed("[DocsProvider] Error cargando documentos");
      console.error("Axios error:", {
        message: error?.message,
        code: error?.code,
        status: response?.status,
        statusText: response?.statusText,
        method: error?.config?.method,
        url: error?.config?.url || requestUrl,
      });

      if (response?.data?.error_id) {
        console.error("Error ID backend:", response.data.error_id);
      }

      console.groupEnd();
      setDocsLoading(false);
      setDocsFlag(true);
      setDocFlagTransfered(true);
    }
  };

  const getGroupedCase = (data) => {
    const enrichedFiles = data || [];

    const groupedByCase = enrichedFiles.reduce((acc, file) => {
      const parts = file.path.split("/");
      const caseId = /^\d+$/.test(parts[1]) ? parts[1] : "sin_carpeta";
      const subFolder = parts.length >= 4 ? parts[2] : "Sin Carpeta";

      if (!acc[caseId]) acc[caseId] = {};
      if (!acc[caseId][subFolder]) acc[caseId][subFolder] = [];

      acc[caseId][subFolder].push(file);
      return acc;
    }, {});

    for (const caseId in groupedByCase) {
      for (const subFolder in groupedByCase[caseId]) {
        groupedByCase[caseId][subFolder].sort((a, b) =>
          a.file_name.localeCompare(b.file_name),
        );
      }
    }

    return groupedByCase;
  };

  useEffect(() => {
    if (caseId) {
      getDocsInfo(caseId);
    }
  }, [caseId, docsChangedFlag]);

  return (
    <DocsContext.Provider
      value={{
        docsInfo,
        docsChangedFlag,
        setDocsChangedFlag,
        docsLoading,
        setDocsLoading,
        getDocsInfo,
        docsInfoTransfered,
        docFlagTransfered,
        docsFlag,
      }}
    >
      {children}
    </DocsContext.Provider>
  );
};
